import { createBroadcastableCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the Rovo broadcast actions command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to create a new Rovo confirmed action.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Rovo confirmed action with the specified content.
 */
export var RovoBroadcastConfirmedActionsCommand = createBroadcastableCommand('rovo-broadcast-confirmed-actions-command');